import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Typography,
    Modal,
    TextField,
    Select,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    IconButton,
    Grid,
    Paper,
    Chip,
} from '@mui/material';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import DashboardLayout from './DashboardLayout';
import axios from 'axios';
import Holidays from 'date-holidays';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import EditIcon from '@mui/icons-material/Edit';
import { Hourglass } from 'react-loader-spinner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';


const localizer = momentLocalizer(moment);

const MarcarFerias = () => {
    const user = React.useMemo(() => JSON.parse(localStorage.getItem('user')), []);
     const [isSubmitting, setIsSubmitting] = useState(false);
    const [submissionComplete, setSubmissionComplete] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [holidays, setHolidays] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showCalendar, setShowCalendar] = useState(false);
    const [selectedYear, setSelectedYear] = useState(moment().year());
    const [yearsAvailable, setYearsAvailable] = useState([]);
    const [feriasData, setFeriasData] = useState([]);
    const [isTableVisible, setIsTableVisible] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedFeria, setSelectedFeria] = useState(null);
    const [editReason, setEditReason] = useState('');
    const [approvedFerias, setApprovedFerias] = useState([]);
    const [summaryDetailModalOpen, setSummaryDetailModalOpen] = useState(false);
    const [selectedSummaryCard, setSelectedSummaryCard] = useState(null);
    const [selectedCalendarDate, setSelectedCalendarDate] = useState(new Date());

    
    const apiBaseURL = 'https://plasticemployers.duckdns.org';      // IP da rede local


// Dicionário de cores para cada seção
const seccaoColors = {
    'Admin': '#1E90FF',
    'Escritorio': '#32CD32',
    'Design': '#8A2BE2',
    'Corte': '#FFA500',
    'Impressao': '#FF69B4',
    'Mini-Flexo': '#008080',
    'Digital': '#A52A2A',
    'Digital-rotativa': '#808080',
    'Armazem': '#00CED1',
    'Logistica': '#FF4500',
    'Comercial': '#FFD700'
  };

    const FeriasTable = ({ feriasData, selectedYear, onOpenEditModal }) => {
        const [isTableVisible, setIsTableVisible] = useState(false);
        // O restante do código permanece o mesmo...
    
        // Filtrar os dados de férias pelo ano selecionado
        const filteredFerias = feriasData.filter((feria) =>
            moment(feria.dias_ferias).year() === selectedYear
        );
    
        const toggleTableVisibility = () => {
            setIsTableVisible(!isTableVisible);
        };

    };
    const toggleTableVisibility = () => {
        setIsTableVisible(!isTableVisible);
    };

    const parseDateList = (diasFerias, yearFilter = selectedYear) => {
        if (!diasFerias) {
            return [];
        }

        return diasFerias
            .split(',')
            .map((day) => day.trim())
            .filter(Boolean)
            .filter((day) => moment(day, 'YYYY-MM-DD', true).isValid())
            .filter((day) => (yearFilter ? moment(day).year() === yearFilter : true));
    };

    const parseFeriaDaysForYear = (feria) => {
        if (!feria?.dias_ferias) {
            return [];
        }

        const validDays = parseDateList(feria.dias_ferias, selectedYear);

        if (validDays.length === 0) {
            return [];
        }

        if (feria.half_day) {
            return [validDays[0]];
        }

        return validDays;
    };

    const formatDayAmount = (value) => {
        const numericValue = Number(value || 0);
        return Number.isInteger(numericValue) ? String(numericValue) : numericValue.toFixed(1);
    };

    const filteredFerias = feriasData.filter((feria) =>
        moment(feria.dias_ferias).year() === selectedYear
    );

    const feriasSummary = React.useMemo(() => {
        const today = moment().startOf('day');
        const base = Number(user?.remaining_holidays || 0);
        const standard = 22;

        const buckets = {
            approved: [],
            pending: [],
            consumed: [],
        };

        feriasData.forEach((feria) => {
            const days = parseFeriaDaysForYear(feria);

            if (days.length === 0) {
                return;
            }

            if (feria.half_day) {
                const day = days[0];
                const dayMoment = moment(day, 'YYYY-MM-DD');
                const entry = {
                    id: `${feria.id}-${day}`,
                    date: day,
                    weight: 0.5,
                    isHalfDay: true,
                };

                if (feria.aprovado_por) {
                    if (dayMoment.isSameOrBefore(today, 'day')) {
                        buckets.consumed.push(entry);
                    } else {
                        buckets.approved.push(entry);
                    }
                } else if (!feria.reprovado_por) {
                    buckets.pending.push(entry);
                }
                return;
            }

            days.forEach((day) => {
                const dayMoment = moment(day, 'YYYY-MM-DD');
                const entry = {
                    id: `${feria.id}-${day}`,
                    date: day,
                    weight: 1,
                    isHalfDay: false,
                };

                if (feria.aprovado_por) {
                    if (dayMoment.isSameOrBefore(today, 'day')) {
                        buckets.consumed.push(entry);
                    } else {
                        buckets.approved.push(entry);
                    }
                } else if (!feria.reprovado_por) {
                    buckets.pending.push(entry);
                }
            });
        });

        const sortEntries = (entries) =>
            [...entries].sort((a, b) => moment(a.date).valueOf() - moment(b.date).valueOf());

        const sumWeights = (entries) =>
            entries.reduce((total, entry) => total + entry.weight, 0);

        const approved = sumWeights(buckets.approved);
        const pending = sumWeights(buckets.pending);
        const consumed = sumWeights(buckets.consumed);
        const remaining = base + standard - (approved + consumed);

        return {
            base,
            standard,
            approved,
            pending,
            consumed,
            remaining,
            details: {
                approved: sortEntries(buckets.approved),
                pending: sortEntries(buckets.pending),
                consumed: sortEntries(buckets.consumed),
            },
        };
    }, [feriasData, selectedYear, user?.remaining_holidays]);

    const summaryCards = [
        {
            key: 'approved',
            title: 'Dias Aprovados',
            subtitle: 'Por gozar',
            value: feriasSummary.approved,
            color: '#2e7d32',
        },
        {
            key: 'pending',
            title: 'Dias por Aprovar',
            subtitle: 'Em aprovação',
            value: feriasSummary.pending,
            color: '#ed6c02',
        },
        {
            key: 'consumed',
            title: 'Gozados',
            subtitle: 'Até hoje',
            value: feriasSummary.consumed,
            color: '#1565c0',
        },
        {
            key: 'remaining',
            title: 'Restantes',
            subtitle: 'Saldo atual',
            value: feriasSummary.remaining,
            color: feriasSummary.remaining < 0 ? '#d32f2f' : '#6a1b9a',
        },
    ];

    const selectedSummaryCardConfig = summaryCards.find((card) => card.key === selectedSummaryCard) || null;
    const selectedSummaryCardDetails = selectedSummaryCard
        ? feriasSummary.details[selectedSummaryCard] || []
        : [];

    const savedDatesForSelectedYear = React.useMemo(() => {
        return feriasData.flatMap((feria) => parseFeriaDaysForYear(feria));
    }, [feriasData, selectedYear]);

    const savedDatesSetForSelectedYear = React.useMemo(() => {
        return new Set(savedDatesForSelectedYear);
    }, [savedDatesForSelectedYear]);

    const localNewSelectedCount = React.useMemo(() => {
        return selectedDates.reduce((total, date) => {
            return total + (savedDatesSetForSelectedYear.has(date) ? 0 : 1);
        }, 0);
    }, [selectedDates, savedDatesSetForSelectedYear]);

    const unsavedSelectedDates = React.useMemo(() => {
        return selectedDates.filter((date) => !savedDatesSetForSelectedYear.has(date));
    }, [selectedDates, savedDatesSetForSelectedYear]);

    const remainingDays = feriasSummary.remaining - localNewSelectedCount;

    useEffect(() => {
        if (user) {
          const fetchHolidays = () => {
            const hd = new Holidays('PT');
            const holidaysList = hd.getHolidays(selectedYear);
            const holidayEvents = holidaysList.map(holiday => ({
              start: new Date(holiday.date),
              end: new Date(holiday.date),
              title: `Feriado: ${holiday.name}`,
              allDay: true,
            }));
            setHolidays(holidayEvents);
          };
      
          const fetchSavedFerias = async () => {
            try {
              const token = localStorage.getItem('access');
              const response = await axios.get(`${apiBaseURL}/api/ferias/?empregado=${user.id}&ano=${selectedYear}`, {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              });
              const ferias = response.data;
              setFeriasData(ferias);
            } catch (error) {
              console.error('Erro ao buscar as férias:', error);
            } finally {
              setLoading(false);
            }
          };
      
          const calculateYearsAvailable = () => {
            const contractYear = moment(user.data_contrato).year();
            const currentYear = moment().year();
            const years = [];
            for (let year = contractYear; year <= currentYear; year++) {
              years.push(year);
            }
            setYearsAvailable(years);
          };
      
          fetchHolidays();
          fetchSavedFerias();
          calculateYearsAvailable();
        }
      }, [user, selectedYear]);

    // Sincronizar datas selecionadas com o que já existe no backend para o ano selecionado
    useEffect(() => {
        setSelectedDates(savedDatesForSelectedYear);
    }, [savedDatesForSelectedYear]);

    const handleSelectYear = (event) => {
        const newYear = event.target.value;
        setSelectedYear(newYear);
        setSelectedDates([]); // Limpa as datas selecionadas para o novo ano
        setLoading(true);
    };

    const handleSelectSlot = (slotInfo) => {
        const date = moment(slotInfo.start).format('YYYY-MM-DD');
        const dayOfWeek = moment(slotInfo.start).day();
        setSelectedCalendarDate(slotInfo.start);

        if (savedDatesSetForSelectedYear.has(date)) {
            alert('Este dia já está registado. Para alterar, use o pedido de alteração na tabela.');
            return;
        }

        // Impede marcação com menos de 7 dias de antecedência
        const selectedDateMoment = moment(slotInfo.start).startOf('day');
        const minAllowedDate = moment().add(7, 'days').startOf('day');
        if (selectedDateMoment.isBefore(minAllowedDate)) {
          alert('Não é permitido marcar férias com menos de 7 dias de antecedência.');
          return;
        }

        if (dayOfWeek === 0 || dayOfWeek === 6) {
            alert('Não é possível marcar férias em fins de semana.');
            return;
        }

        if (selectedDates.includes(date)) {
            setSelectedDates(selectedDates.filter(d => d !== date));
        } else if (remainingDays > 0) {
            setSelectedDates([...selectedDates, date]);
        } else {
            alert('Você já marcou o limite máximo de dias de férias.');
        }
    };

    const handleSelectCalendarEvent = (event) => {
        if (event?.start) {
            setSelectedCalendarDate(event.start);
        }
    };

    const localSelectedEvents = React.useMemo(() => (
        unsavedSelectedDates.map((date) => ({
            id: `local-${date}`,
            start: new Date(date),
            end: new Date(date),
            title: 'Nova Seleção',
            localPending: true,
            kind: 'local',
            seccao: user?.seccao || null,
            employeeName: user?.nome_completo || 'Você',
            halfDay: false,
        }))
    ), [unsavedSelectedDates, user?.nome_completo, user?.seccao]);

    const fetchApprovedFerias = async () => {
        try {
            const token = localStorage.getItem('access');
            const response = await axios.get(`${apiBaseURL}/api/ferias/aprovadas/?ano=${selectedYear}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setApprovedFerias(response.data);
        } catch (error) {
            console.error('Erro ao buscar as férias aprovadas:', error);
        }
      };

    useEffect(() => {
        if (showCalendar) {
            fetchApprovedFerias();
        }
    }, [showCalendar, selectedYear]);

    const handleSave = async () => {
        console.log('handleSave chamado');
        setIsSubmitting(true);
        setSubmissionComplete(false);
    
        try {
            const token = localStorage.getItem('access');
            const today = moment().format('YYYY-MM-DD');
    
            const existingDates = feriasData.map(f => moment(f.dias_ferias).format('YYYY-MM-DD'));
            const newDates = selectedDates.filter(date => !existingDates.includes(moment(date).format('YYYY-MM-DD')));
    
            if (newDates.length === 0) {
                alert('Nenhuma nova data de férias para salvar.');
                return;
            }
    
            // Construir os dados para salvar no banco de dados
            const savePromises = newDates.map(date => {
                const formattedDate = moment(date).format('YYYY-MM-DD');
                const feriasData = {
                    empregado_id: user.id,
                    empregado: user.id,
                    ano: selectedYear,
                    dias_restantes: remainingDays - 1,
                    dias_ferias: formattedDate,
                    data_marcada: today,
                };
                return axios.post(`${apiBaseURL}/api/ferias/`, feriasData, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
            });
    
            await Promise.all(savePromises);
    
            // Criar a mensagem consolidada para as notificações
            const formattedDates = newDates.map(date => moment(date).format('DD/MM/YYYY')).join('\n');
            const notificationMessage = `O empregado ${user.nome_completo} marcou os seguintes dias de férias:\n\n${formattedDates}\n\nPor favor inspecione quando possível.`;
    
            // Enviar a notificação consolidada
            await axios.post(
                `${apiBaseURL}/api/notifications/`,
                {
                    message: notificationMessage,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            
            setSubmissionComplete(true);
        } catch (error) {
            console.error('Erro ao salvar as férias:', error);
            alert('Erro ao salvar as férias.');
        } finally {
            setTimeout(() => setIsSubmitting(false), 1500);
            setModalOpen(false);
        }
    };

    const handleRequestEdit = async () => {
        if (!selectedFeria || !editReason.trim()) {
            alert('Por favor, insira um motivo para a alteração.');
            return;
        }
    
        try {
            const token = localStorage.getItem('access');
            const formattedDate = moment(selectedFeria.dias_ferias).format('DD/MM/YYYY');
            const message = `O empregado ${user.nome_completo} quer alterar o dia ${formattedDate} com o motivo: ${editReason}`;
    
            await axios.post(`${apiBaseURL}/api/notifications/`, {
                message: message,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
    
            alert('Solicitação de alteração enviada com sucesso!');
            setEditModalOpen(false);
            setEditReason('');
        } catch (error) {
            console.error('Erro ao solicitar alteração:', error);
            alert('Erro ao solicitar alteração. Tente novamente.');
        }
    };

    const handleOpenEditModal = (feria) => {
        setSelectedFeria(feria);
        setEditModalOpen(true);
    };

    const handleCloseEditModal = () => {
        setEditModalOpen(false);
        setEditReason('');
    };

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    const handleOpenSummaryDetailModal = (cardKey) => {
        setSelectedSummaryCard(cardKey);
        setSummaryDetailModalOpen(true);
    };

    const handleCloseSummaryDetailModal = () => {
        setSummaryDetailModalOpen(false);
        setSelectedSummaryCard(null);
    };

    // Eventos aprovados (todos os empregados) – usando o endpoint de férias aprovadas
    const approvedEvents = React.useMemo(() => (
        approvedFerias.flatMap((feria) => {
            const dates = parseDateList(feria.dias_ferias, selectedYear);
            return dates.map((date) => ({
                id: `approved-${feria.id}-${date}`,
                start: new Date(date),
                end: new Date(date),
                title: feria.empregado && feria.empregado.first_name
                    ? feria.empregado.first_name
                    : 'Aprovado',
                aprovado: true,
                kind: 'approved',
                seccao: feria.empregado ? feria.empregado.seccao : null,
                employeeName: feria.empregado?.nome_completo || feria.empregado?.first_name || 'Aprovado',
                halfDay: Boolean(feria.half_day),
            }));
        })
    ), [approvedFerias, selectedYear]);

    // Eventos pendentes – as suas férias marcadas que ainda não foram aprovadas
    const pendingEvents = React.useMemo(() => (
        feriasData
            .filter((feria) => !feria.aprovado_por && !feria.reprovado_por && feria.dias_ferias)
            .flatMap((feria) => {
                const dates = parseFeriaDaysForYear(feria);
                return dates.map((date) => ({
                    id: `pending-${feria.id}-${date}`,
                    start: new Date(date),
                    end: new Date(date),
                    title: user?.nome_completo?.split(' ')[0] || 'Pendente',
                    pending: true,
                    kind: 'pending',
                    seccao: user.seccao || null,
                    employeeName: user.nome_completo || 'Você',
                    halfDay: Boolean(feria.half_day),
                }));
            })
    ), [feriasData, user, selectedYear]);

    const calendarEvents = React.useMemo(() => ([
        ...approvedEvents,
        ...pendingEvents,
        ...localSelectedEvents,
        ...holidays.map((holiday, index) => ({
            ...holiday,
            id: `holiday-${index}-${moment(holiday.start).format('YYYY-MM-DD')}`,
            kind: 'holiday',
            holiday: true,
            employeeName: null,
            halfDay: false,
        })),
    ]), [approvedEvents, pendingEvents, localSelectedEvents, holidays]);

    const selectedCalendarDateKey = moment(selectedCalendarDate).format('YYYY-MM-DD');

    const selectedCalendarEvents = React.useMemo(() => {
        const isSameDay = (eventDate) =>
            moment(eventDate).format('YYYY-MM-DD') === selectedCalendarDateKey;

        const kindOrder = { holiday: 0, local: 1, pending: 2, approved: 3 };

        return calendarEvents
            .filter((event) => isSameDay(event.start))
            .sort((a, b) => {
                const aOrder = kindOrder[a.kind] ?? 99;
                const bOrder = kindOrder[b.kind] ?? 99;
                if (aOrder !== bOrder) {
                    return aOrder - bOrder;
                }
                return (a.title || '').localeCompare(b.title || '', 'pt');
            });
    }, [calendarEvents, selectedCalendarDateKey]);

    const selectedCalendarStats = React.useMemo(() => {
        const stats = {
            total: selectedCalendarEvents.length,
            approved: 0,
            pending: 0,
            local: 0,
            holidays: 0,
            halfDays: 0,
        };

        selectedCalendarEvents.forEach((event) => {
            if (event.halfDay) stats.halfDays += 1;
            if (event.kind === 'approved') stats.approved += 1;
            else if (event.kind === 'pending') stats.pending += 1;
            else if (event.kind === 'local') stats.local += 1;
            else if (event.kind === 'holiday') stats.holidays += 1;
        });

        return stats;
    }, [selectedCalendarEvents]);
        const eventPropGetter = (event) => {
            if (event.localPending) {
              return {
                style: {
                    backgroundColor: '#1976d2',
                    border: '1px dashed #0d47a1',
                    color: '#fff',
                    borderRadius: 6,
                    fontWeight: 600,
                }
              };
            }
            if (event.aprovado) {
              return {
                style: {
                    backgroundColor: seccaoColors[event.seccao] || '#6a1b9a',
                    color: '#fff',
                    borderRadius: 6,
                }
              };
            }
            if (event.pending) {
              return {
                style: {
                    backgroundColor: '#ed6c02',
                    color: '#fff',
                    borderRadius: 6,
                    border: '1px solid rgba(0,0,0,0.2)',
                }
              };
            }
            if (event.holiday || event.title.includes('Feriado')) {
              return {
                style: {
                    backgroundColor: '#d32f2f',
                    color: '#fff',
                    borderRadius: 6,
                }
              };
            }
            if (event.start.getDay() === 0 || event.start.getDay() === 6) {
              return { style: { backgroundColor: 'red' } };
            }
            return {};
        };

    const dayPropGetter = (date) => {
        const isWeekend = date.getDay() === 0 || date.getDay() === 6;
        const isSelected = moment(date).isSame(selectedCalendarDate, 'day');
        const style = {};

        if (isWeekend) {
            style.backgroundColor = '#fff8f8';
        }
        if (isSelected) {
            style.boxShadow = 'inset 0 0 0 2px #1976d2';
            style.backgroundColor = isWeekend ? '#fceeee' : '#eef6ff';
        }

        return { style };
    };

    const calendarMessages = {
        today: 'Hoje',
        previous: 'Anterior',
        next: 'Seguinte',
        month: 'Mês',
        week: 'Semana',
        day: 'Dia',
        agenda: 'Agenda',
        date: 'Data',
        time: 'Hora',
        event: 'Evento',
        noEventsInRange: 'Sem eventos neste período',
        showMore: (total) => `+${total} mais`,
    };

    const CalendarEventContent = ({ event }) => {
        const label = event.holiday
            ? 'Feriado'
            : `${event.title}${event.halfDay ? ' (1/2)' : ''}`;

        return (
            <Box
                title={`${event.employeeName || event.title || ''}${event.halfDay ? ' (Meio dia)' : ''}`}
                sx={{
                    fontSize: '0.72rem',
                    fontWeight: 600,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    px: 0.25,
                }}
            >
                {label}
            </Box>
        );
    };

    if (loading) {
        return <Typography>Carregando...</Typography>;
    }

    return (
        <DashboardLayout>
            <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
               Férias
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', marginBottom: 2 }}>
                <Select
                    value={selectedYear}
                    onChange={handleSelectYear}
                    sx={{ mb: { xs: 2, sm: 0 }, minWidth: { xs: 120, sm: 150 } }}
                >
                    {yearsAvailable.map(year => (
                        <MenuItem key={year} value={year}>
                            {year}
                        </MenuItem>
                    ))}
                </Select>
                <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                    Dias Restantes: {formatDayAmount(remainingDays)}
                </Typography>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    disabled={remainingDays < 0} // Desativa o botão apenas quando não há dias disponíveis
                    sx={{ mb: { xs: 2, sm: 0 } }}
                >
                    Salvar Alterações
                </Button>
            </Box>
            {remainingDays === 0 && (
                <Typography variant="h6" color="error" gutterBottom sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                    Você não tem mais dias de férias disponíveis.
                </Typography>
            )}
            <Typography variant="h6" sx={{ fontSize: { xs: '1rem', sm: '1.25rem' } }}>
                Férias relativas ao ano {selectedYear}
            </Typography>
            <Box sx={{ my: 2 }}>
                <Grid container spacing={2}>
                    {summaryCards.map((card) => (
                        <Grid item xs={12} sm={6} md={3} key={card.key}>
                            <Paper
                                onClick={() => handleOpenSummaryDetailModal(card.key)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                        event.preventDefault();
                                        handleOpenSummaryDetailModal(card.key);
                                    }
                                }}
                                sx={{
                                    p: 2,
                                    cursor: 'pointer',
                                    borderLeft: `6px solid ${card.color}`,
                                    transition: 'transform 0.15s ease, box-shadow 0.15s ease',
                                    '&:hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: 4,
                                    },
                                    '&:focus-visible': {
                                        outline: `2px solid ${card.color}`,
                                        outlineOffset: 2,
                                    },
                                }}
                            >
                                <Typography variant="body2" color="text.secondary">
                                    {card.title}
                                </Typography>
                                <Typography variant="h4" sx={{ fontWeight: 700, color: card.color, lineHeight: 1.1, my: 0.5 }}>
                                    {formatDayAmount(card.value)}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {card.subtitle}
                                </Typography>
                            </Paper>
                        </Grid>
                    ))}
                </Grid>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                    Clique num card para ver os dias (meio dia aparece identificado).
                </Typography>
            </Box>
            <Box sx={{ marginBottom: 2 }}>
            <Button
                variant="contained"
                color="primary"
                onClick={toggleTableVisibility}
                sx={{ marginBottom: 2 }}
            >
                {isTableVisible ? 'Ocultar Férias' : 'Mostrar Férias'}
            </Button>
            {isTableVisible && (
                <Box sx={{ overflowX: 'auto' }}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>Dia da marcação</TableCell>
                                <TableCell>Dia de férias</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Data de Aprovação</TableCell>
                                <TableCell>Ações</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
    {filteredFerias.map((feria) => (
        <TableRow key={feria.id}>
            <TableCell>{moment(feria.data_marcada).format('DD/MM/YYYY')}</TableCell>
            <TableCell>{feria.dias_ferias || 'N/A'}</TableCell>
            <TableCell
                sx={{
                    color:
                        feria.aprovado_por ? 'green' :
                        feria.reprovado_por ? 'red' :
                        'orange', // Lógica para o status
                    fontWeight: 'bold',
                }}
            >
                {feria.aprovado_por ? 'Aprovado' : feria.reprovado_por ? 'Reprovado' : 'Em Aprovação'}
            </TableCell>
            <TableCell>{feria.data_aprovacao ? moment(feria.data_aprovacao).format('DD/MM/YYYY') : 'N/A'}</TableCell>
            <TableCell>
                <IconButton onClick={() => handleOpenEditModal(feria)} color="primary">
                    <EditIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    ))}
</TableBody>
                    </Table>
                </Box>
            )}
            {!isTableVisible && (
                <Typography variant="body2" color="textSecondary">
                    Clique no botão acima para ver as suas férias marcadas e o status.
                </Typography>
            )}
        </Box>
        <Button
            variant="contained"
            color="secondary"
            onClick={() => {
                setShowCalendar(!showCalendar);
            }}
            sx={{ mb: 2 }}
            >
            {showCalendar ? 'Esconder Calendário' : 'Mostrar Calendário'}
            </Button>
            {showCalendar && (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', lg: 'row' },
                        gap: 2,
                        mt: 1,
                        mb: 2,
                    }}
                >
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                        <Paper sx={{ p: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                                Calendário de Férias
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                                <Chip size="small" label="Aprovado" sx={{ bgcolor: '#2e7d32', color: '#fff' }} />
                                <Chip size="small" label="Pendente" sx={{ bgcolor: '#ed6c02', color: '#fff' }} />
                                <Chip size="small" label="Nova seleção" sx={{ bgcolor: '#1976d2', color: '#fff' }} />
                                <Chip size="small" label="Feriado" sx={{ bgcolor: '#d32f2f', color: '#fff' }} />
                            </Box>
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.5 }}>
                                Clique num evento para ver detalhes. Clique num dia livre para selecionar/desselecionar férias.
                            </Typography>
                            <Box
                                sx={{
                                    '& .rbc-calendar': {
                                        fontSize: '0.9rem',
                                    },
                                    '& .rbc-month-view': {
                                        borderRadius: 1.5,
                                        overflow: 'hidden',
                                        borderColor: 'divider',
                                    },
                                    '& .rbc-header': {
                                        py: 1,
                                        fontWeight: 700,
                                        backgroundColor: '#f7fafc',
                                    },
                                    '& .rbc-date-cell': {
                                        pr: 0.75,
                                    },
                                    '& .rbc-today': {
                                        backgroundColor: '#fff7cc',
                                    },
                                    '& .rbc-off-range-bg': {
                                        backgroundColor: '#fafafa',
                                    },
                                    '& .rbc-event': {
                                        minHeight: 20,
                                        padding: '1px 3px',
                                        boxShadow: 'none',
                                    },
                                    '& .rbc-event-label': {
                                        display: 'none',
                                    },
                                    '& .rbc-show-more': {
                                        fontWeight: 700,
                                        color: '#1976d2',
                                    },
                                }}
                            >
                                <Calendar
                                    localizer={localizer}
                                    events={calendarEvents}
                                    views={['month']}
                                    defaultView="month"
                                    selectable
                                    popup
                                    messages={calendarMessages}
                                    onSelectSlot={handleSelectSlot}
                                    onSelectEvent={handleSelectCalendarEvent}
                                    style={{ height: 620 }}
                                    eventPropGetter={eventPropGetter}
                                    dayPropGetter={dayPropGetter}
                                    components={{ event: CalendarEventContent }}
                                />
                            </Box>
                        </Paper>
                    </Box>

                    <Box sx={{ width: { xs: '100%', lg: 340 }, flexShrink: 0 }}>
                        <Paper sx={{ p: 2, mb: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                                {moment(selectedCalendarDate).format('DD/MM/YYYY')}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                                Detalhes do dia selecionado
                            </Typography>

                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                                <Chip size="small" label={`Total: ${selectedCalendarStats.total}`} />
                                <Chip size="small" label={`Aprov.: ${selectedCalendarStats.approved}`} color="success" variant="outlined" />
                                <Chip size="small" label={`Pend.: ${selectedCalendarStats.pending}`} color="warning" variant="outlined" />
                                <Chip size="small" label={`Local: ${selectedCalendarStats.local}`} color="primary" variant="outlined" />
                                <Chip size="small" label={`Feriados: ${selectedCalendarStats.holidays}`} color="error" variant="outlined" />
                                <Chip size="small" label={`Meios dias: ${selectedCalendarStats.halfDays}`} color="secondary" variant="outlined" />
                            </Box>

                            {selectedCalendarEvents.length === 0 ? (
                                <Typography variant="body2" color="text.secondary">
                                    Sem eventos neste dia.
                                </Typography>
                            ) : (
                                <Box sx={{ display: 'grid', gap: 1, maxHeight: 420, overflowY: 'auto', pr: 0.5 }}>
                                    {selectedCalendarEvents.map((event) => (
                                        <Box
                                            key={event.id || `${event.title}-${event.start}`}
                                            sx={{
                                                p: 1.25,
                                                borderRadius: 1.5,
                                                border: '1px solid',
                                                borderColor: 'divider',
                                                backgroundColor: event.localPending ? 'rgba(25, 118, 210, 0.06)' : 'background.paper',
                                            }}
                                        >
                                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                                                <Typography variant="body2" sx={{ fontWeight: 700 }}>
                                                    {event.employeeName || event.title}
                                                </Typography>
                                                <Chip
                                                    size="small"
                                                    label={
                                                        event.holiday ? 'Feriado'
                                                            : event.localPending ? 'Local'
                                                            : event.aprovado ? 'Aprovado'
                                                            : event.pending ? 'Pendente'
                                                            : 'Evento'
                                                    }
                                                    color={
                                                        event.holiday ? 'error'
                                                            : event.localPending ? 'primary'
                                                            : event.aprovado ? 'success'
                                                            : event.pending ? 'warning'
                                                            : 'default'
                                                    }
                                                    variant={event.localPending || event.pending ? 'outlined' : 'filled'}
                                                />
                                            </Box>
                                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                                                {event.seccao ? `Seção: ${event.seccao}` : 'Sem seção'}
                                                {event.halfDay ? ' • Meio dia' : ''}
                                                {event.title && !event.holiday ? ` • ${event.title}` : ''}
                                            </Typography>
                                        </Box>
                                    ))}
                                </Box>
                            )}
                        </Paper>
                    </Box>
                </Box>
            )}
            <Modal
                open={modalOpen}
                onClose={handleCloseModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: 300, sm: 400 },
                        maxHeight: '80vh', // Define uma altura máxima para o modal
                        overflowY: 'auto', // Permite scroll vertical quando o conteúdo ultrapassa a altura definida
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography
                        id="modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}
                    >
                        Confirmar Férias
                    </Typography>
                    <Typography
                        id="modal-description"
                        sx={{ mt: 2, fontSize: { xs: '0.9rem', sm: '1rem' } }}
                    >
                        Você está prestes a marcar férias nos seguintes dias:
                    </Typography>

                    <ul>
                        {Object.entries(
                            selectedDates
                                .map((date) => moment(date).format('YYYY-MM-DD')) // Formata as datas
                                .sort((a, b) => new Date(a) - new Date(b)) // Ordena em ordem crescente
                                .reduce((acc, date) => {
                                    const month = moment(date).format('MMMM'); // Extrai o mês (nome completo)
                                    acc[month] = acc[month] || [];
                                    acc[month].push(moment(date).format('DD/MM/YYYY')); // Adiciona a data formatada ao mês
                                    return acc;
                                }, {})
                        ).map(([month, dates]) => (
                            <li key={month}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                    {month.charAt(0).toUpperCase() + month.slice(1)} {/* Capitaliza o mês */}
                                </Typography>
                                <ul>
                                    {dates.map((d) => (
                                        <li key={d}>{d}</li>
                                    ))}
                                </ul>
                            </li>
                        ))}
                    </ul>

                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            marginTop: 2,
                        }}
                    >
                        <Button
                            onClick={handleCloseModal}
                            variant="contained"
                            color="secondary"
                            sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
                        >
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSave}
                            variant="contained"
                            color="primary"
                            sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
                        >
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={editModalOpen}
                onClose={handleCloseEditModal}
                aria-labelledby="modal-title"
                aria-describedby="modal-description"
            >
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: { xs: 300, sm: 400 }, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
                    <Typography id="modal-title" variant="h6" component="h2" sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
                        Solicitar Alteração de Férias
                    </Typography>
                    <Typography id="modal-description" sx={{ mt: 2, fontSize: { xs: '0.9rem', sm: '1rem' } }}>
                        Você está prestes a solicitar a alteração do dia {selectedFeria && moment(selectedFeria.dias_ferias).format('DD/MM/YYYY')} de férias.
                    </Typography>
                    <TextField
                        label="Motivo"
                        multiline
                        rows={4}
                        placeholder="Digite o motivo para alterar o dia de férias"
                        value={editReason}
                        onChange={(e) => setEditReason(e.target.value)}
                        fullWidth
                        sx={{ mt: 2 }}
                    />
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: 2 }}>
                        <Button onClick={handleCloseEditModal} variant="contained" color="secondary" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                            Cancelar
                        </Button>
                        <Button onClick={handleRequestEdit} variant="contained" color="primary" sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                            Confirmar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal
                open={summaryDetailModalOpen}
                onClose={handleCloseSummaryDetailModal}
                aria-labelledby="summary-detail-title"
                aria-describedby="summary-detail-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: 320, sm: 500 },
                        maxHeight: '80vh',
                        overflowY: 'auto',
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 3,
                        borderRadius: 1,
                    }}
                >
                    <Typography id="summary-detail-title" variant="h6" component="h2" sx={{ mb: 1 }}>
                        {selectedSummaryCardConfig?.title || 'Detalhes'}
                    </Typography>
                    <Typography id="summary-detail-description" variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        {selectedSummaryCardConfig
                            ? `${formatDayAmount(selectedSummaryCardConfig.value)} dia(s) no ano ${selectedYear}.`
                            : `Ano ${selectedYear}`}
                    </Typography>

                    {selectedSummaryCard === 'remaining' ? (
                        <Box sx={{ display: 'grid', gap: 1 }}>
                            <Typography variant="body2">
                                Saldo base: <strong>{formatDayAmount(feriasSummary.base)}</strong>
                            </Typography>
                            <Typography variant="body2">
                                Dias padrão anuais: <strong>{formatDayAmount(feriasSummary.standard)}</strong>
                            </Typography>
                            <Typography variant="body2">
                                Aprovados (por gozar): <strong>{formatDayAmount(feriasSummary.approved)}</strong>
                            </Typography>
                            <Typography variant="body2">
                                Gozados: <strong>{formatDayAmount(feriasSummary.consumed)}</strong>
                            </Typography>
                            <Typography variant="body2">
                                Fórmula: saldo base + 22 - aprovados - gozados
                            </Typography>
                        </Box>
                    ) : selectedSummaryCardDetails.length > 0 ? (
                        <Box component="ul" sx={{ pl: 2, m: 0 }}>
                            {selectedSummaryCardDetails.map((entry) => (
                                <li key={entry.id}>
                                    <Typography variant="body2" sx={{ mb: 0.5 }}>
                                        {moment(entry.date).format('DD/MM/YYYY')}
                                        {entry.isHalfDay ? ' (Meio dia)' : ''}
                                    </Typography>
                                </li>
                            ))}
                        </Box>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            Não existem dias nesta categoria para {selectedYear}.
                        </Typography>
                    )}

                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                        <Button onClick={handleCloseSummaryDetailModal} variant="contained" color="primary">
                            Fechar
                        </Button>
                    </Box>
                </Box>
            </Modal>
            <Modal open={isSubmitting} aria-labelledby="loading-modal" aria-describedby="loading-description">
    <Box
        sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 300,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
        }}
    >
        {submissionComplete ? (
            <>
                <CheckCircleIcon color="success" sx={{ fontSize: 80 }} />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Submetido com sucesso!
                </Typography>
            </>
        ) : (
            <>
                <Hourglass
                    visible={true}
                    height="80"
                    width="80"
                    ariaLabel="hourglass-loading"
                    colors={['#306cce', '#72a1ed']}
                />
                <Typography variant="h6" sx={{ mt: 2 }}>
                    Processando...
                </Typography>
            </>
        )}
    </Box>
</Modal>
        </DashboardLayout>
    );
};

export default MarcarFerias;
